import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

// TODO
export enum ChainId {
  MAINNET = 12008, // OpsidePubliczkEVMV2
  // ROPSTEN = 3,
  // RINKEBY = 4,
  // GÖRLI = 5,
  // KOVAN = 42,
  // RolluxTestnet = 57000,
  OpsideTestnet = 51178,
  // OpsidePubliczkEVMV2 = 12008
  ODXTestnet = 12020,
  ZKFairTestnet = 43851
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

// TODO
export const FACTORY_ADDRESS = '0x8170cB45A1945f8108a2fa414fa5A49e2D719F28'

// TODO
export const INIT_CODE_HASH = '0xd9fb46c0e5370a51bdf07d67bb88aa25425ecb4105f35a4926878652821698c2'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
